module.exports = __webpack_public_path__ + "img/full.9cf5386e.png";